import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Header = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 88px;
  padding: 16px;
  margin-bottom: 5px;
  background-color: ${COLORS.black};
  border-bottom: 1px solid ${COLORS.line};
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
`;

export default Header;
